import { IconLayer } from '@deck.gl/layers';

import type { IconLayerProps } from '@/types';

import { HUD_PARAMETERS } from '@/utils/constants/map';

export const makeIconLayer = <T>({
  id,
  data,
  visible,
  atlas,
  mapping,
  icon = 'marker',
  getPosition,
  offset,
  size,
  color,
  angle,
  depth,
  updateTriggers,
  billboard = true,
  pickable = false,
  onClick,
}: IconLayerProps<T>) => {
  return new IconLayer<T>({
    id,
    data,
    visible: visible ?? true,
    pickable: pickable,
    onClick,
    iconAtlas: atlas,
    iconMapping: mapping,
    getIcon: () => icon,
    getPosition,
    getPixelOffset: offset,
    getSize: size,
    getColor: color,
    getAngle: angle ?? 0,
    billboard,
    parameters: HUD_PARAMETERS,
    getPolygonOffset: (): [number, number] => [0, depth],
    updateTriggers: updateTriggers || {},
  });
};
